import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=a1c11f16&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=a1c11f16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c11f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1c11f16')) {
      api.createRecord('a1c11f16', component.options)
    } else {
      api.reload('a1c11f16', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=a1c11f16&scoped=true", function () {
      api.rerender('a1c11f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ali/edit.vue"
export default component.exports